export function getCommentMarkdownRequest(commentMarkdown?: string) {
  return commentMarkdown ? { comment_markdown: commentMarkdown } : {};
}
